<template>
    <div>
        <div class="d-flex align-items-center mb-3">
            <div>
                <h1 class="page-header mb-0"><i class="fa fa-arrow-down-up-across-line"></i> Emelőgépek</h1>
            </div>
            <div class="ms-auto">
                <crane-button @crane-added="addedCrane" :locations="locationslinear" :machine_types="machine_types"></crane-button>
            </div>
        </div>
        <panel title="Emelőgépek">
            <Loading title="Emelőgépek betöltése" v-if="!cranes"></Loading>
            <NoRecords v-else-if="cranes.length == 0" title="Nincsenek Emelőgépek" subtitle="Hozzon létre újat"
                main_icon="fa fa-arrow-down-up-across-line"></NoRecords>
                <vue-good-table v-else
					:columns="columns" 
					:rows="cranes" 
					:search-options="{ enabled: false, placeholder: 'Keresés...' }" 
					:pagination-options="{
						enabled: true, 
						position: 'bottom',
						firstLabel : 'Első Lap',
						lastLabel : 'Utolsó Lap',
						nextLabel: 'következő',
						prevLabel: 'előző',
						rowsPerPageLabel: 'Sor oldalanként',
						ofLabel: '/',
						allLabel: 'Összes',
						infoFn: (params) => `első sorszám: ${params.firstRecordOnPage}`, 
					}"
				>
					<template slot="table-row" slot-scope="props">
						<span v-if="props.column.field == 'actions'">
							<crane-button :crane="props.row" @crane-updated="updatedCrane" :locations="locationslinear" :machine_types="machine_types"></crane-button>
							<button @click="deleteCrane(props.row.id)" class="btn btn-danger mx-1" title="törlés"><i class="fa fa-trash"></i></button>
						</span>
						<span v-else-if="props.column.field == 'operational'">
							<i class="fa" :class="{ 'fa-check-circle text-green': props.row.operational, 'fa-times-circle text-red': !props.row.operational }"></i>
							<span :class="{ 'fw-bold': !props.row.operational }">
								{{ props.row.operational_name }}
							</span>
						</span>
						<span v-else>
							{{props.formattedRow[props.column.field]}}
						</span>
					</template>
				</vue-good-table>
        </panel>
    </div>
</template>

<script>
import Crane from '../../apis/Crane';
import Loading from '../../components/Loading';
import NoRecords from '../../components/NoRecords';
import CraneButton from './partials/CraneButton';

export default {
    components: {
        Loading, NoRecords, CraneButton
    },
    data() {
        return {
            cranes: false,
            machine_types: [],
            columns: [
					{
						label: 'Sorszám',
						field: 'number',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Gyártási szám',
						field: 'serial_number',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Név',
						field: 'name',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Típus',
						field: 'machine_type_name',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Terület',
						field: 'location_name',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Üzemképes',
						field: 'operational',
						filterOptions : {
							filterDropdownItems: [
								{ value: 1, text: 'igen' },
								{ value: 0, text: 'nem' },
							],
							enabled:true,
							placeholder: 'Összes',
						}
					},
					{
						label: 'Műveletek',
						field: 'actions',
						sortable: false,
						thClass: 'text-end',
						tdClass: 'text-end buttons-wide-3'
					} 
				]
        }
    },
    created() {
        this.getCranes();
        Crane.machineTypes()
            .then(response => {
                this.machine_types = response.data;
            });
    },
    computed:{
        cranes_c(){
            return this.cranes;
        },
		locationslinear() {
			return this.$store.state.locationslinear;
		},
    },
    methods: {
        getCranes() {
            Crane.index().then(response => {
                this.cranes = response.data;
            })
        },
        addedCrane(crane){
            this.cranes.push(crane);
        },
        updatedCrane(crane){
            const index = this.cranes.findIndex(c => c.id == crane.id);
            this.cranes.splice(index,1)
            this.cranes.splice(index,0,crane)
        },
		deleteCrane(id){
			if(confirm('Biztosan törölni szeretné?')){
				Crane.delete(id).then(() => {
					this.cranes = this.cranes.filter(c => c.id != id);
				})
			}
		}
    }
}
</script>
